// extracted by mini-css-extract-plugin
export var shake = "_3-0";